/**
 * @file LabelCutLinesField.tsx
 * @description Переключатель «Линии реза» в диалогах печати этикеток —
 *   товара и ячеек (phase19.22 шаг 5, решение пользователя 2026-09-26).
 *
 * Строка — `label` во всю ширину и ≥56px, как в «Рабочем месте»: сам тумблер
 * 20×36px, в перчатке в него не попасть, а скрытый `input` base-ui `Switch`
 * внутри `label` переключается тапом по любому месту строки.
 */

import { LABEL_TEXT } from "./label-texts";
import { Switch } from "../../ui/switch";

interface Props {
  value: boolean;
  onChange: (value: boolean) => void;
}

export function LabelCutLinesField({ value, onChange }: Props) {
  return (
    <label className="flex min-h-14 cursor-pointer items-center justify-between gap-3 rounded-xl bg-surface-low px-4 py-3">
      <span className="flex min-w-0 flex-col">
        <span className="text-sm font-medium">{LABEL_TEXT.cutLinesTitle}</span>
        <span className="text-xs text-on-surface-variant">{LABEL_TEXT.cutLinesHint}</span>
      </span>
      <Switch
        checked={value}
        onCheckedChange={(next) => onChange(Boolean(next))}
        aria-label={LABEL_TEXT.cutLinesTitle}
        className="shrink-0"
      />
    </label>
  );
}
